var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfessionalIndemnity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 7.3,
    r: 7.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8,27.5c0-0.8,0-1.6,0-2.4c0.1-4.3,0.1-7.2-2.5-10.2c0.2-0.4,0.3-0.9,0.3-1.4c0-1.7-1.4-3.1-3.1-3.1c-1.7,0-3.1,1.4-3.1,3.1s1.4,3.1,3.1,3.1c0.5,0,0.9-0.1,1.3-0.3c2,2.4,2,4.7,1.9,8.7c0,0.6,0,1.3,0,2c0,0,0,0,0,0h-2.1v-1.9c0-2.4-1.3-4.5-3.4-5.6c-2.6-1.4-6.7-3-11.2-3s-8.6,1.6-11.2,3c-2.1,1.1-3.4,3.2-3.4,5.6v1.9h-2c0-0.7,0-1.4,0-2c-0.1-4-0.1-6.3,1.9-8.7c0.4,0.2,0.8,0.3,1.3,0.3c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1s-3.1,1.4-3.1,3.1c0,0.5,0.1,1,0.3,1.4c-2.6,3-2.6,5.9-2.5,10.2c0,0.7,0,1.5,0,2.3c-2.5,0.8-4.2,3.1-4.2,5.9v2.1c0,2.9,2,5.4,4.7,6l1.5,7.7c0.1,0.5,0.5,0.8,1,0.8h31.2c0.5,0,0.9-0.4,1-0.8l1.5-7.7c2.7-0.7,4.7-3.1,4.7-6v-2.1C47.9,30.6,46.2,28.3,43.8,27.5z M43.8,35.4c0,1.1-0.9,2.1-2.1,2.1H8.3c-1.1,0-2.1-0.9-2.1-2.1v-2.1c0-1.1,0.9-2.1,2.1-2.1h33.3c1.1,0,2.1,0.9,2.1,2.1L43.8,35.4L43.8,35.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessionalIndemnity);
export default __webpack_public_path__ + "static/media/professional-indemnity.ee43690e91e1802f546735d64b37d960.svg";
export { ForwardRef as ReactComponent };